import { useMemo } from 'react'
import { Select, Typography } from 'antd'
import useDirectory from 'hooks/useDirectory'
import { AnnotationType } from 'types/building'

import DropdownIconCustom from 'components/icons/DropdownIconCustom'

type Props = {
  selectedChildrenFolder: any
  selectedFolder: AnnotationType
  changeSelectedFolder: (value: any) => void
  t: any
  onOpenAlertSetting?: () => void
  // Whether an Alert already exists or not
  hasAlert?: boolean
}

export default function AnnotationTypeSelector({
  selectedChildrenFolder,
  selectedFolder,
  changeSelectedFolder,
  t,
  onOpenAlertSetting = undefined,
  hasAlert = false
}: Props) {
  const { getAnnotationList } = useDirectory()

  const annotationList = useMemo(() => getAnnotationList(), [getAnnotationList])

  if (selectedChildrenFolder && selectedFolder !== AnnotationType.MEMO)
    return null

  return (
    <div className="flex gap-[5.5rem] items-center h-10 mb-[10px] w-full">
      <Typography className="font-bold text-[14px] leading-[14px] text-[#021120]">
        {t('building.annotationType')}
      </Typography>
      <Select
        value={selectedFolder}
        onSelect={changeSelectedFolder}
        options={annotationList}
        suffixIcon={<DropdownIconCustom colorIcon="#000000" />}
        style={{
          width: 240,
          fontSize: 14,
          color: '#021120'
        }}
      />
      <div className="ml-auto flex flex-col items-end justify-center relative -top-1 gap-1">
        <span
          className={`text-[10px] leading-3 font-bold ${
            hasAlert ? 'text-[#3451D1]' : 'text-[#E73A3A]'
          }`}
        >
          {hasAlert ? '設定中' : '未設定'}
        </span>
        <div
          className="flex items-center justify-center border border-solid border-[#3451D1] text-[#3451D1] rounded cursor-pointer px-4 h-[30px] text-[12px] font-bold bg-white"
          onClick={() => {
            if (onOpenAlertSetting) {
              onOpenAlertSetting()
            }
          }}
        >
          アラート設定
        </div>
      </div>
    </div>
  )
}

AnnotationTypeSelector.defaultProps = {
  onOpenAlertSetting: undefined,
  hasAlert: false
}
